import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiUsers, FiFileText, FiGlobe, FiDollarSign, FiBarChart2 } = FiIcons;

const QuickNav = () => {
  const navItems = [
    { path: '/', icon: FiHome, label: 'Dashboard', color: 'bg-indigo-500' },
    { path: '/agencies', icon: FiUsers, label: 'Agencies', color: 'bg-blue-500' },
    { path: '/articles', icon: FiFileText, label: 'Articles', color: 'bg-green-500' },
    { path: '/domains', icon: FiGlobe, label: 'Domains', color: 'bg-yellow-500' },
    { path: '/earnings', icon: FiDollarSign, label: 'Earnings', color: 'bg-red-500' },
    { path: '/analytics', icon: FiBarChart2, label: 'Analytics', color: 'bg-purple-500' }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4"
    >
      {navItems.map((item, index) => (
        <motion.div
          key={item.path}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05 }}
        >
          <Link
            to={item.path}
            className="flex flex-col items-center p-4 bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all hover:-translate-y-1"
          >
            <div className={`w-12 h-12 ${item.color} rounded-full flex items-center justify-center mb-3`}>
              <SafeIcon icon={item.icon} className="w-6 h-6 text-white" />
            </div>
            <span className="text-sm font-medium text-gray-700">{item.label}</span>
          </Link>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default QuickNav;